import { PageState } from 'models/PageState';

export const getAppShell = (state: PageState): PageState['appShell'] => state.appShell;
export const selectIsThecaSearchEnabled = (state: PageState): boolean =>
  state.appShell.isThecaSearchFeatureToggle;

export const selectIsValidated = (state: PageState): boolean => state.appShell.isValidated;
export const getCurrencySymbol = (state: PageState): string => state.appShell.currencySymbol;

export const selectShouldUseGecpHeader = (state: PageState): boolean =>
  state.appShell.shouldUseGecpHeader;

export const selectCdnUrl = (state: PageState): string => state.appShell.links.cdnUrl;

export const selectSiteUrl = (state: PageState): string => state.appShell.links.site;
